import React from "react"
import { useSelector } from "react-redux"
import { Product } from "./Product"

export function Products() {
  const selector = (state) => {
    return state.cart.products
  }

  const data = useSelector(selector)

  const products = data.map((p, i) => (
    <Product
      key={i}
      id={p.id}
      index={i}
      img={p.img}
      title={p.title}
      price={p.totalPrice}
      dough={p.selected.dough}
      size={p.selected.sizes}
      amount={p.totalCount}
    />
  ))

  return <div>{products}</div>
}
